module.exports = __webpack_public_path__ + "img/nj.b1e41187.jpg";